<template>
  <div>
    <div class="search-bar-margin-bottom-cla">
      <el-form ref="searchForm"
               :model="params"
               inline
               label-width="80">
        <el-form-item prop="name"
                      :label="$t('dictionary.name')">
          <el-input type="text"
                    v-model.trim="params.name"
                    :placeholder="this.$t('developer.dicNamePla')"></el-input>
        </el-form-item>
        <el-form-item prop="type"
                      :label="$t('dictionary.type')">
          <el-input type="text"
                    v-model.trim="params.type"
                    :placeholder="this.$t('developer.dicTypePla')"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary"
                     icon="el-icon-search"
                     @click="query()">{{$t('common.search')}}</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="black_panel_cla">
      <div class="header-button-bar">
        <zk-tool-bar @add="add"></zk-tool-bar>
      </div>
      <zk-table :columns="columns"
                :data="data"
                @update="update"
                @remove="remove"></zk-table>
      <div class="pagination-margin-top">
        <el-pagination background
                       @size-change="pageSizeChange(arguments[0], commQuery)"
                       @current-change="curPageChange(arguments[0], commQuery)"
                       :current-page="pager.curPage"
                       :page-size="pager.pageSize"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="pager.total"></el-pagination>
      </div>
    </div>

    <el-dialog :title="state.title"
               :visible.sync="state.saveOrUpdate"
               :before-close="beforeClose"
               width="45%">
      <zk-sys-dict-save-or-update ref="saveOrUpdate"
                                  :form="row"
                                  :isUpdate="state.isUpdate"></zk-sys-dict-save-or-update>
      <span slot="footer"
            class="dialog-footer">
        <el-button @click="onCancel">{{$t('common.cancel')}}</el-button>
        <el-button type="primary"
                   @click="saveOrUpdate">{{$t('common.confirm')}}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import * as dictService from '../../../services/dictionary'
export default {
  name: 'zk-system-dictionary',
  data () {
    let _self = this
    let data = []
    let params = {}
    let columns = [
      {
        prop: 'type',
        label: this.$t('dictionary.dictType'),
        minWidth: '140px'
      },
      {
        prop: 'name',
        label: this.$t('dictionary.dictName'),
        minWidth: '140px'
      },
      {
        prop: 'value',
        label: this.$t('dictionary.value')
      },
      {
        prop: 'sortNo',
        label: this.$t('dictionary.sortNo')
      },
      {
        prop: 'remark',
        label: this.$t('common.remark')
      },
      {
        prop: 'i18nKey',
        label: this.$t('common.i18nKey'),
        minWidth: '140px'
      },
      {
        label: this.$t('common.operation'),
        minWidth: '100px',
        render: (h, params) => {
          return h('zk-operate-bar', {
            props: {
              isTextBtn: true
            },
            on: {
              update () {
                _self.row = params.row
                _self.update()
              },
              remove () {
                _self.row = params.row
                _self.remove()
              }
            }
          })
        }
      }
    ]
    let row = {}
    let state = {
      saveOrUpdate: false,
      title: '',
      isUpdate: false
    }
    return {
      columns,
      row,
      data,
      state,
      params
    }
  },
  methods: {
    query () {
      this.pager.curPage = 1
      this.commQuery()
    },
    commQuery () {
      dictService
        .query({
          pager: this.pager,
          params: this.params
        })
        .then((data) => {
          this.data = data.payload.results.results || data.payload.results
          this.pager.curPage =
            data.payload.curPage || data.payload.results.curPage
          this.pager.total =
            data.payload.totalRecords || data.payload.results.totalRecords
          this.pager.pageSize =
            data.payload.pageSize || data.payload.results.pageSize
        })
    },
    add () {
      this.row = {}
      this.state.isUpdate = false
      this.state.title = this.$t('dictionary.addDict')
      this.state.saveOrUpdate = true
    },
    update () {
      this.state.isUpdate = true
      this.state.title = this.$t('dictionary.updateDict')
      this.state.saveOrUpdate = true
    },
    saveOrUpdate () {
      let _self = this
      this.$refs.saveOrUpdate
        .save()
        .then((data) => {
          if (data.code === '00000000') {
            this.$message({
              type: 'success',
              message: `${this.state.title} ` + this.$t('common.success')
            })
            this.commQuery()
            _self.state.saveOrUpdate = false
          } else {
            this.$message({
              type: 'error',
              message: data.message
            })
            _self.state.saveOrUpdate = true
          }
        })
        .catch((data) => {
          if (data) {
            this.$message({
              type: 'error',
              message: data.message
            })
          }
        })
    },
    onCancel () {
      this.state.saveOrUpdate = false
      this.row = {}
      this.$refs.saveOrUpdate.resetFields()
    },
    remove () {
      this.$confirm(
        this.$t('dictionary.confirmDeleteTip'),
        this.$t('common.confirmDelete'),
        {
          confirmButtonText: this.$t('common.yes'),
          cancelButtonText: this.$t('common.delete'),
          type: 'warning'
        }
      )
        .then(() => {
          dictService
            .remove({
              id: this.row.id
            })
            .then(() => {
              this.$message({
                type: 'success',
                message: this.$t('common.successDelete')
              })
              this.query()
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('common.cancelDelete')
          })
        })
    },
    beforeClose () {
      this.$refs.saveOrUpdate.resetFields()
      this.state.saveOrUpdate = false
    }
  },
  mounted () {
    this.query()
  }
}
</script>



// WEBPACK FOOTER //
// src/cdpBase/baseComponents/systemDictionary/src/main.vue